import React, { useEffect, useState } from "react";

import NoDataFound from "./NoDataFound";
import PostCard from "./PostCard";
import { timeSince } from "../../utils/generalLiveCenter";
import { loadStyles } from "../../utils/cssLoader";

const News = ({
  data,
  id,
  newsType = "match",
  sport,
  baseUrl,
  dataClient,
  loadCSS,
  title,
}) => {
  const [nData, setNData] = useState(data);
  const [pageCount, setPageCount] = useState(1);

  const handleLoadMore = async () => {
    const nextPage = pageCount + 1;
    try {
      const res = await fetch(
        `${baseUrl}/${sport}/${newsType}/${id}/news?page=${nextPage}`,
        {
          headers: {
            Token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
          },
        }
      );
      if (!res.ok) throw new Error(res?.statusText);
      const json = await res?.json();
      setNData((prev) => ({
        ...prev,
        data: [...(prev?.data || []), ...(json?.data || [])],
        metadata: json?.metadata,
      }));
      setPageCount(nextPage);
    } catch (err) {
      console.error("Failed to load more news:", err);
    }
  };

  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const dataAttr = container?.getAttribute("data-listingdata");

    if (dataAttr) {
      try {
        const parsed = JSON.parse(dataAttr);
        setNData(parsed?.data || []);
      } catch (e) {
        console.error("Failed to parse data-listingdata:", e);
      }
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("news");
    }
  }, [loadCSS]);

  const sourceData = dataClient ? nData : data;

  return (
    <section className="detail_news">
      {title && <h1>{title}</h1>}
      {sourceData && sourceData?.data?.length > 0 ? (
        <>
          <div className="three_columns">
            {sourceData &&
              sourceData?.data?.map((item, index) => (
                <PostCard clas="vertical_post" key={item?.id || index}>
                  <PostCard.Img
                    imgURL={item?.imgu || undefined}
                    externalLink={item?.link}
                    slug={item?.hdl}
                  />
                  <PostCard.Discription>
                    <PostCard.TitleSlug externalLink={item?.link}>
                      {item?.hdl || ""}
                    </PostCard.TitleSlug>
                    <div className="author_date">
                      <PostCard.Author
                        showBy={false}
                        authorName={item?.author?.name}
                      ></PostCard.Author>
                      <span>{timeSince(item?.sdt)}</span>
                    </div>
                  </PostCard.Discription>
                </PostCard>
              ))}
          </div>
          {dataClient &&
            sourceData?.pagination?.current_page + 1 <
            sourceData?.pagination?.last_page ? (
            <div className="load-more center_button">
              <button
                className="button button_primary"
                onClick={handleLoadMore}
              >
                See More
              </button>
            </div>
          ) : null}
        </>
      ) : (
        <NoDataFound />
      )}
    </section>
  );
};

export default News;
